import BaseActionAbstract from 'cio/app-models/action-abstracts/base';
import { task } from 'ember-concurrency';
import ActionModel, { ActionType } from '../../models/action';
import { computed } from '@ember/object';
import { isBlank } from '@ember/utils';
import DataActionBodyAttributeRows from 'cio/app-models/data-action/body-attribute-rows';
import DataActionRecipientCondition from '../data-action/recipient-condition';

const EDITABLE_PROPERTIES: string[] = ['name', 'preconditions'];
const DIRTY_DEPENDENCIES = `action.{${EDITABLE_PROPERTIES.join(',')}}`;

export default class CreateOrUpdatePersonAbstract extends BaseActionAbstract {
  type = 'create_or_update_person';

  // BaseActionAbstract is an untyped EmberObject, and TS complains that
  // ActionModel can't be assigned to type "null"
  // @ts-ignore
  action!: ActionModel;
  // @ts-ignore
  actionType!: ActionType;

  bodyRows!: DataActionBodyAttributeRows;
  recipientCondition!: DataActionRecipientCondition;

  init() {
    super.init(...arguments);

    this.bodyRows = DataActionBodyAttributeRows.deserialize(this.action.attributes, { minimumRowsCount: 0 });
    this.recipientCondition = DataActionRecipientCondition.deserialize(this.action.recipient);
  }

  name = '';

  _editableProperties: string[] = EDITABLE_PROPERTIES;
  _dirtyDependencies: string = DIRTY_DEPENDENCIES;

  @computed('name')
  get errors() {
    if (isBlank(this.name)) {
      return {
        name: ["can't be blank"],
      };
    }
    return;
  }

  // TS complains that the type of prepareForSave here isn't compatible with the
  // one in BaseActionAbstract. BaseActionAbstract isn't typed so it's hard to
  // define the types over there.
  // @ts-ignore
  prepareForSave(): ActionModel {
    // This just calls super, so it's not really necessary to have this method
    // defined, but it's here to override the return type of the super method, so
    // that saveTask below has the right types
    return super.prepareForSave() as any as ActionModel;
  }

  saveTask = task({ drop: true }, async () => {
    let action = this.prepareForSave();

    try {
      let response = await action.save();
      this.prepareForEdit();
      return response;
    } catch (e) {
      action.rollbackAttributes();
      throw e;
    }
  });

  deleteTask = task({ drop: true }, async () => {
    return this.action.campaign.removeActionFromWorkflow(this.action);
  });
}
